<template>
  <div class="page page--calculate">
    <Head>
      <title>
        {{ $t("speed-calculator-title") }} - {{ $t("speed-title") }}
      </title>
      <body class="site--speed" />
      <meta
        name="description"
        :content="$t('page.speed-calculator.description')"
      />
      <meta name="og:title" :content="$t('speed-calculator-title')" />
      <meta
        name="og:description"
        :content="$t('page.speed-calculator.description')"
      />
    </Head>
    <h1>
      <router-link :to="pathForLocale({ path: '/how-fast-am-i-going' })">{{
        $t("speed-calculator-title")
      }}</router-link>
    </h1>
    <AdUnit unit="1" />
    <SpeedCalculator />
    <AdUnit unit="2" />
    <TheFooter
      :fast="false"
      :elevation="true"
      :title="$t('page.speed-calculator.heading')"
    >
      <div class="section section--about">
        <div class="text-block" v-html="$t('page.speed-calculator.html')"></div>
      </div>
      <template v-slot:nav>
        <li>
          <router-link :to="pathForLocale({ path: '/how-fast-am-i-going' })">{{
            $t("speed-title")
          }}</router-link>
        </li>
        <li>
          <router-link :to="pathForLocale({ path: '/speed-calculator' })">{{
            $t("speed-calculator-title")
          }}</router-link>
        </li>
        <li>
          <router-link :to="pathForLocale({ path: '/speed-converter' })">{{
            $t("speed-converter-title")
          }}</router-link>
        </li>
      </template>
    </TheFooter>
  </div>
</template>
<script>
import { Head } from "@vueuse/head";
import { pathForLocale } from "@/helpers";
import TheFooter from "@/components/TheFooter.vue";
import AdUnit from "@/components/AdUnit.vue";
import SpeedCalculator from "@/components/SpeedCalculator.vue";

export default {
  components: {
    SpeedCalculator,
    TheFooter,
    AdUnit,
    Head
  },
  data() {
    return {};
  },
  methods: {
    pathForLocale
  }
};
</script>
